export default "__VITE_ASSET__BVjmsAu8__"